// extracted by mini-css-extract-plugin
export default {"footerArea":"Footers_footerArea__A+7N7"};